export const DataRouteParamWorkshopId = 'workshopId';
